module.exports = __webpack_public_path__ + "static/img/idea_left.dffb327.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/home/idea_left.png
// module id = CDj4
// module chunks = 3